import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "sidebarButton" }
const _hoisted_2 = { class: "selectDate flex" }
const _hoisted_3 = { class: "category" }
const _hoisted_4 = { class: "options" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "warpit_icon_TE-font-colorB" }, null, -1)
const _hoisted_6 = ["onClick"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "warpit_icon_calendar" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_AccordionTab = _resolveComponent("AccordionTab")!
  const _component_Accordion = _resolveComponent("Accordion")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("span", {
        class: "showSidebar sidebar",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('sidebar-toggled')))
      })
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Calendar, {
        class: "calendarInput",
        modelValue: _ctx.from,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.from) = $event)),
        showIcon: true,
        placeholder: "Od",
        dateFormat: "dd.mm.yy"
      }, null, 8, ["modelValue"]),
      _createVNode(_component_Calendar, {
        class: "calendarInput",
        modelValue: _ctx.until,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.until) = $event)),
        showIcon: true,
        placeholder: "Do",
        dateFormat: "dd.mm.yy"
      }, null, 8, ["modelValue"])
    ]),
    _createVNode(_component_Accordion, {
      multiple: true,
      class: "events news"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_AccordionTab, {
          header: _ctx.$t('sidebar_events.type')
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("button", {
                  class: _normalizeClass({ selected: _ctx.selectedCategoryId === null }),
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.setCategory(null)))
                }, [
                  _hoisted_5,
                  _createTextVNode(_toDisplayString(_ctx.$t("sidebar_events.everything")), 1)
                ], 2),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categories, (category) => {
                  return (_openBlock(), _createElementBlock("button", {
                    key: category.id,
                    onClick: ($event: any) => (_ctx.setCategory(category)),
                    class: _normalizeClass({ selected: _ctx.selectedCategoryId === category.id })
                  }, [
                    _hoisted_7,
                    _createTextVNode(_toDisplayString(category.name), 1)
                  ], 10, _hoisted_6))
                }), 128))
              ])
            ])
          ]),
          _: 1
        }, 8, ["header"])
      ]),
      _: 1
    })
  ], 64))
}